import { useAppStore, type AppRoute } from '@/store/useAppStore'
import { Logo } from './Logo'
import { SegmentControl, type SegmentItem } from './SegmentControl'
import { ApiActivity, ConnectionDot, ModeBadge } from './Indicators'
import { LogoutIcon, RadarIcon, BotIcon } from '@/components/common/icons'

export function Header() {
  const route = useAppStore((s) => s.route)
  const setRoute = useAppStore((s) => s.setRoute)
  const logout = useAppStore((s) => s.logout)
  const mode = useAppStore((s) => s.engine?.mode ?? null)
  const running = useAppStore((s) => s.engine?.running ?? false)
  const wsStatus = useAppStore((s) => s.wsStatus)

  // §7: индикатор слева от «Авто-бот» горит, когда бот включён (running).
  const segments: SegmentItem<AppRoute>[] = [
    { key: 'parser', label: 'Парсинг', icon: <RadarIcon size={16} /> },
    { key: 'autobot', label: 'Авто-бот', icon: <BotIcon size={16} />, dot: running },
  ]

  return (
    <header className="header">
      <div className="header__brand">
        <Logo />
      </div>

      <div className="header__center">
        <SegmentControl items={segments} value={route} onChange={setRoute} />
      </div>

      <div className="header__right">
        <ConnectionDot status={wsStatus} />
        <ApiActivity />
        <ModeBadge mode={mode} />
        <button type="button" className="icon-btn" onClick={logout} title="Выйти (сбросить токен)">
          <LogoutIcon size={18} />
          <span className="sr-only">Выйти</span>
        </button>
      </div>
    </header>
  )
}
